import { Button } from 'antd';
import React from 'react';

interface ILanguageSwitcherProps {
  handleLanguageChange: (value: string) => void;
  language: string;
}
const LanguageSwitcher: React.FC<ILanguageSwitcherProps> = (props) => {

  return (
    <>
      <Button.Group>
        <Button
          shape="round"
          onClick={() => props.handleLanguageChange('en')}
          type={props.language === 'en' ? 'primary' : 'default'}>
          English
        </Button>
        <Button
          shape="round"
          onClick={() => props.handleLanguageChange('lo')}
          type={props.language === 'lo' ? 'primary' : 'default'}>
          ພາສາລາວ
        </Button>
      </Button.Group>
    </>
  );
};

export default LanguageSwitcher;